import React, { createContext, useReducer, useState, useContext, useEffect } from 'react';
import Box from '@amzn/meridian/box';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import Checkbox from '@amzn/meridian/checkbox';
import Column from '@amzn/meridian/column';
import ControlGroup from '@amzn/meridian/control-group';
import Responsive from '@amzn/meridian/responsive';
import { FormattedMessage } from 'react-intl';
import ButtonGroup, { ButtonOption } from '@amzn/meridian/button-group';
import Heading from '@amzn/meridian/heading';
import Table, { TableRow, TableCell, TableActionBar } from '@amzn/meridian/table';
import Tooltip from '@amzn/meridian/tooltip';
import FullScreen from 'react-full-screen';
import Link from '@amzn/meridian/link';
import checkSmallTokens from '@amzn/meridian-tokens/base/icon/check-small';
import alertKnockoutTokens from '@amzn/meridian-tokens/base/icon/alert-knockout';
import closeSmallTokens from '@amzn/meridian-tokens/base/icon/close-small';
import clockTokens from '@amzn/meridian-tokens/base/icon/clock';
import { css } from 'emotion';
import Icon from '@amzn/meridian/icon';
import Pagination from '@amzn/meridian/pagination';
import Button from '@amzn/meridian/button';
import { CSVLink } from 'react-csv';
import Select, { SelectOption } from '@amzn/meridian/select';
import Tag from '@amzn/meridian/tag';
import BreadcrumbGroup from '@amzn/meridian/breadcrumb/breadcrumb-group';
import Breadcrumb from '@amzn/meridian/breadcrumb';
import TableCell$1 from '@amzn/meridian/table/table-cell';
import TableRow$1 from '@amzn/meridian/table/table-row';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var ShipmentTypeFilterReducer = function ShipmentTypeFilterReducer(state, action) {
  switch (action.type) {
    case "SET_SHIPMENTTYPE_FILTERS":
      {
        var newState = _extends({}, state, {
          shipmentTypeFilters: action.shipmentTypeFilters
        });
        return newState;
      }
    default:
      return state;
  }
};

var ShipmentTypeFilterContext = createContext();
var ShipmentTypeFilterContextProvider = function ShipmentTypeFilterContextProvider(props) {
  var state = {
    shipmentTypeFilters: []
  };
  var _useReducer = useReducer(ShipmentTypeFilterReducer, state),
    ViewModelG = _useReducer[0],
    dispatchG = _useReducer[1];
  return /*#__PURE__*/React.createElement(ShipmentTypeFilterContext.Provider, {
    value: {
      ViewModelG: ViewModelG,
      dispatchG: dispatchG
    }
  }, props.children);
};

var ShipmentTypeFilter = function ShipmentTypeFilter() {
  var _useState = useState([]),
    checkBoxValues = _useState[0],
    setCheckBoxValues = _useState[1];
  var _useContext = useContext(ShipmentTypeFilterContext),
    ViewModelG = _useContext.ViewModelG,
    dispatchG = _useContext.dispatchG;
  var updateShipmentTypeFilters = function updateShipmentTypeFilters(checkBoxValues) {
    setCheckBoxValues(checkBoxValues);
    dispatchG({
      type: "SET_SHIPMENTTYPE_FILTERS",
      shipmentTypeFilters: checkBoxValues
    });
  };
  useEffect(function () {
    setCheckBoxValues(ViewModelG.shipmentTypeFilters);
    sessionStorage.setItem("filter", JSON.stringify(ViewModelG.shipmentTypeFilters));
  }, []);
  return /*#__PURE__*/React.createElement(Column, {
    spacing: "200"
  }, /*#__PURE__*/React.createElement(ControlGroup, {
    name: "shipmentTypeFilters[]",
    onChange: updateShipmentTypeFilters,
    value: checkBoxValues
  }, /*#__PURE__*/React.createElement(Checkbox, {
    value: "MFNPickup"
  }, "Ship With Amazon"), /*#__PURE__*/React.createElement(Checkbox, {
    value: "Undeliverables"
  }, "Undeliverables"), /*#__PURE__*/React.createElement(Checkbox, {
    value: "CReturns"
  }, "Customer Returns")));
};

var SMALL = "840px";
var LARGE = "1260px";

var _spacingInset_shortha, _spacingInset_shortha2, _isMobile;
var responsiveProps = {
  spacingInset_shorthand2: (_spacingInset_shortha = {
    default: "small large"
  }, _spacingInset_shortha[SMALL] = "small medium", _spacingInset_shortha),
  spacingInset_shorthand4: (_spacingInset_shortha2 = {
    default: "medium large none large"
  }, _spacingInset_shortha2[SMALL] = "medium medium none medium", _spacingInset_shortha2),
  isMobile: (_isMobile = {
    default: false
  }, _isMobile[SMALL] = true, _isMobile)
};

var DeviceLayoutContext = React.createContext();
var useDeviceLayout = function useDeviceLayout() {
  return useContext(DeviceLayoutContext);
};
var DeviceLayoutProvider = function DeviceLayoutProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Responsive, {
    query: "max-width",
    props: responsiveProps
  }, function (_ref2) {
    var spacingInset_shorthand2 = _ref2.spacingInset_shorthand2,
      spacingInset_shorthand4 = _ref2.spacingInset_shorthand4,
      isMobile = _ref2.isMobile;
    return /*#__PURE__*/React.createElement(DeviceLayoutContext.Provider, {
      value: {
        spacingInset_shorthand2: spacingInset_shorthand2,
        spacingInset_shorthand4: spacingInset_shorthand4,
        isMobile: isMobile
      }
    }, children);
  });
};

var ShipmentTypeField = function ShipmentTypeField() {
  var _useDeviceLayout = useDeviceLayout(),
    spacingInset_shorthand2 = _useDeviceLayout.spacingInset_shorthand2;
  return /*#__PURE__*/React.createElement(Row, {
    widths: ["grid-12"],
    spacingInset: spacingInset_shorthand2
  }, /*#__PURE__*/React.createElement(Box, {
    type: "fill",
    spacingInset: "300"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Text, {
    type: "h100"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.ShipmentType",
    defaultMessage: "Shipment Type"
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(ShipmentTypeFilter, null)))));
};

var ReverseFilterReducer = function ReverseFilterReducer(state, action) {
  switch (action.type) {
    case "SELECT_WAVE_VIEW":
      {
        var newState = _extends({}, state, {
          waveViewType: action.waveViewType
        });
        return newState;
      }
    default:
      return state;
  }
};

var REVERSE_PAGE_HEADERS = {
  REVERSE: {
    tab: "reverse.tabHeading",
    tabAlt: "Reverse",
    head: "reverse.heading",
    headAlt: "Reverse",
    desc: "reverse.description",
    descAlt: "An overview of packages and containers being processed to depart from the station in reverse"
  }
};
var VISUAL_GRID_VIEW = "VISUAL_GRID_VIEW";
var TABULAR_GRID_VIEW = "TABULAR_GRID_VIEW";
var HOVER_DESCRIPTION = {
  AT_RISK: {
    desc: "reverse.hoverDescriptionAtRisk",
    descAlt: "Number of containers not loaded with 30 minutes or less to CPT."
  }
};

var ReverseFilterContext = createContext();
var ReverseFilterContextProvider = function ReverseFilterContextProvider(props) {
  var state = {
    waveViewType: VISUAL_GRID_VIEW
  };
  var _useReducer = useReducer(ReverseFilterReducer, state),
    viewModelF = _useReducer[0],
    dispatchF = _useReducer[1];
  return /*#__PURE__*/React.createElement(ReverseFilterContext.Provider, {
    value: {
      viewModelF: viewModelF,
      dispatchF: dispatchF
    }
  }, props.children);
};

var ReverseViewSelector = function ReverseViewSelector() {
  var _useDeviceLayout = useDeviceLayout(),
    spacingInset_shorthand4 = _useDeviceLayout.spacingInset_shorthand4;
  var _useContext = useContext(ReverseFilterContext),
    viewModelF = _useContext.viewModelF,
    dispatchF = _useContext.dispatchF;
  var toggleView = function toggleView(newValue) {
    dispatchF({
      type: 'SELECT_WAVE_VIEW',
      waveViewType: newValue
    });
  };
  return /*#__PURE__*/React.createElement(Row, {
    spacingInset: spacingInset_shorthand4
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    value: viewModelF.waveViewType,
    onChange: toggleView
  }, /*#__PURE__*/React.createElement(ButtonOption, {
    value: VISUAL_GRID_VIEW
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.visualView",
    defaultMessage: "Visual view"
  })), /*#__PURE__*/React.createElement(ButtonOption, {
    value: TABULAR_GRID_VIEW
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.tableView",
    defaultMessage: "Table view"
  }))));
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var ReverseHeader = function ReverseHeader(_ref) {
  var head = _ref.head,
    headAlt = _ref.headAlt,
    desc = _ref.desc,
    descAlt = _ref.descAlt;
  var _useDeviceLayout = useDeviceLayout(),
    spacingInset_shorthand2 = _useDeviceLayout.spacingInset_shorthand2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Column, {
    spacingInset: spacingInset_shorthand2,
    spacing: "none"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 2,
    type: "h400",
    alignment: "left"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: head,
    defaultMessage: headAlt
  })), /*#__PURE__*/React.createElement(Text, {
    color: "secondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: desc,
    defaultMessage: descAlt
  }))));
};
ReverseHeader.propTypes = {
  head: propTypes.string,
  headAlt: propTypes.string,
  desc: propTypes.string,
  descAlt: propTypes.string
};

var PENDING_DEPART = "Pending Depart";
var PENDING_LOADING = "Pending Loading";
var PENDING_STAGE = "Pending Stage";
var DEPARTED = "Departed";
var AT_RISK = "At Risk";
var CLOSED_FAILED = "Closed Failed";
var PENDING_CLOSE = "Pending Close";
var PackageTypeMapForFetchingPackageMetrics = {
  MFNPickup: "MFNPickup",
  Undeliverables: "Delivery",
  CReturns: ["CReturns", "Abandoned"]
};
var PackageTypeMapForFetchingContainerMetrics = {
  MFNPickup: "SWA",
  Undeliverables: "UNDELIVERED",
  CReturns: "C_RETURN"
};

var ScrollableElementWrapper = function ScrollableElementWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: "auto"
    }
  }, children);
};

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var TIMEOUT_STRING = "timeout";
var TRACKING_ID = "Tracking ID";
var ROUTE_CODE = "Route Code";
var STATE = "State";
var REASON = "Reason";
var SORT_ZONE = "Sort Zone";
var CONTAINER_ID = "Container ID";
var STATUS = "Status";
var RESOURCE_LABEL = "Resource Label";
var VOLUME = "Volume";
var DESTINATION = "Destination";
var STACKING_FILTER = "Stacking Filter";
var OPENED_TIME = "Opened Time";
var CLOSED_TIME = "Closed Time";
var CPT = "CPT";
var VRID = "VRID";
var ContainerState = {
  OPENED: "OPENED",
  CLOSE_FAILED: "CLOSE_FAILED",
  CLOSED: "CLOSED",
  STAGED: "STAGED",
  LOADED: "LOADED",
  DEPARTED: "DEPARTED"
};
var ContainerMetric = {
  PENDING_CLOSE: "Pending Close",
  PENDING_STAGE: "Pending Stage",
  PENDING_DEPART: "Pending Depart",
  CLOSE_FAILED: "Close Failed",
  AT_RISK: "At Risk"
};
var PENDING_STOW_TABLE_COLUMNS = [TRACKING_ID, ROUTE_CODE, STATE, REASON, SORT_ZONE];
var CONTAINER_TABLE_COLUMNS = [CONTAINER_ID, STATUS, RESOURCE_LABEL, VOLUME, DESTINATION, STACKING_FILTER, OPENED_TIME, CLOSED_TIME, CPT, VRID];

var getNodeId = function getNodeId() {
  var queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('stationCode');
};
function convertSecondsToDDMM(milliseconds) {
  var time = new Date(parseInt(milliseconds, 10));
  var date = time.getDate();
  var month = time.getMonth() + 1;
  if (date < 10) date = '0' + date;
  if (month < 10) month = '0' + month;
  return month + ':' + date;
}
function convertSecondsToHHMM(milliseconds) {
  var time = new Date(parseInt(milliseconds, 10));
  return ('0' + time.getHours()).slice(-2) + ':' + ('0' + time.getMinutes()).slice(-2);
}
function convertSecondsToHHMMSS(milliseconds) {
  var time = new Date(parseInt(milliseconds, 10));
  return ('0' + time.getHours()).slice(-2) + ':' + ('0' + time.getMinutes()).slice(-2) + ':' + time.getSeconds();
}
function getRegion() {
  var url = window.location.href;
  return url.includes("eu.") ? "eu" : url.includes("jp.") ? "jp" : "na";
}
function convertLocaleTime(epochMills) {
  if (epochMills === 0 || epochMills === 2147483647) {
    return '-';
  }
  var dateTimeStr = new Date(epochMills).toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h24',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });
  if (!dateTimeStr) {
    return "-";
  }
  var dateTimeString = dateTimeStr.split(" ");
  var dateStr = dateTimeString[0].replace(',', '');
  var timeStr = dateTimeString[1];
  var month = dateStr.split('/')[0];
  var date = dateStr.split('/')[1];
  var year = dateStr.split('/')[2];
  dateStr = year + "-" + month + "-" + date;
  var hour = timeStr.split(':')[0];
  var minutes = timeStr.split(':')[1];
  var seconds = timeStr.split(':')[2];
  timeStr = hour + ":" + minutes + ":" + seconds;
  return dateStr + " " + timeStr;
}
function getIcon(container, index) {
  var val = container.containerState[index];
  if (val > 0) {
    return checkSmallTokens;
  } else if (val < 0) {
    return alertKnockoutTokens;
  } else if (shouldActivateTimer(container, index)) {
    return clockTokens;
  } else {
    return closeSmallTokens;
  }
}
function shouldActivateTimer(container, index) {
  if (index === 0 || container.containerState[index] === 1) {
    return false;
  }
  return container.status === "CLOSED" && Date.now() - container.closedTime >= 5 * 60 * 1000 && container.containerState[index - 1] === 1;
}
function withRefreshTime(callback, refreshTime) {
  var repeat = setInterval(callback, refreshTime);
  callback();
  return repeat;
}

var getDocumentURL = function getDocumentURL() {
  try {
    return Promise.resolve(postMessagePromised(window.parent, {
      method: 'getDocumentURL',
      args: {}
    }, '*'));
  } catch (e) {
    return Promise.reject(e);
  }
};
var getAPIGatewayDataFromParent = function getAPIGatewayDataFromParent(args) {
  try {
    return Promise.resolve(postMessagePromised(window.parent, {
      method: 'getAPIGatewayDataFromParent',
      args: args
    }, '*'));
  } catch (e) {
    return Promise.reject(e);
  }
};
var postMessagePromises = {};
function generateGuid() {
  function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  }
  return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
}
function postMessagePromised(targetWindow, message, targetOrigin, timeout) {
  var newGuid = generateGuid();
  message.guid = newGuid;
  postMessagePromises[newGuid] = {};
  postMessagePromises[newGuid]['promise'] = new Promise(function (resolve, reject) {
    postMessagePromises[newGuid]['resolve'] = resolve;
    postMessagePromises[newGuid]['reject'] = reject;
    targetWindow.postMessage(message, targetOrigin);
    if (timeout) {
      setTimeout(function () {
        postMessagePromises[newGuid].resolve(TIMEOUT_STRING);
        console.log("TimeOut: " + message.method);
      }, timeout);
    }
  });
  return postMessagePromises[newGuid].promise;
}
window.addEventListener("message", onNewPostMessageFromParent, false);
function onNewPostMessageFromParent(event) {
  if (event.data.method && subscribeAbleEvents.hasOwnProperty(event.data.method)) {
    subscribeAbleEvents[event.data.method](event.data);
  }
}
var subscribeAbleEvents = {
  "sendCycleDataToChild": sendCycleDataToChild,
  "sendApiGatewayResponse": sendApiGatewayResponse,
  "sendDocumentURL": sendDocumentURL,
  "sendCapabilityResponse": sendCapabilityResponse,
  "sendLocaleResponse": sendChildData,
  "sendFeatureStatus": sendResponseData
};
function sendCycleDataToChild(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}
function sendApiGatewayResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}
function sendDocumentURL(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}
function sendCapabilityResponse(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}
function sendChildData(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.childData);
  }
}
function sendResponseData(data) {
  if (postMessagePromises[data.guid]) {
    postMessagePromises[data.guid].resolve(data.responseData);
  }
}

var getPackageMetrics = function getPackageMetrics(dispatch, shipmentTypeFilters) {
  try {
    var nodeId = getNodeId();
    var mappedFilters = getMappingForPackageFilters(shipmentTypeFilters);
    var request = {
      nodeId: nodeId,
      metrics: ["PENDING_STOW_COUNT", "REVERSE_STOWED"],
      filters: mappedFilters
    };
    var _temp3 = _catch(function () {
      var args = getAPIGatewayRequestForPackageMetricsData(request);
      return Promise.resolve(getAPIGatewayDataFromParent(args)).then(function (response) {
        var output = response.data;
        if (output.packageMetricsData) {
          dispatch({
            type: "GET_PACKAGE_METRICS_RESPONSE",
            packageMetricsData: getPackageMetricsData(output.packageMetricsData)
          });
        }
      });
    }, function () {
      console.log("Error");
    });
    return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(function () {}) : void 0);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getContainerFromApi = function getContainerFromApi(dispatch, shipmentTypeFilters) {
  try {
    var nodeId = getNodeId();
    var updatedShipmentTypeFilters = [];
    shipmentTypeFilters.forEach(function (selectedValue) {
      if (Object.keys(PackageTypeMapForFetchingContainerMetrics).includes(selectedValue)) {
        var val = PackageTypeMapForFetchingContainerMetrics[selectedValue];
        if (Array.isArray(val)) {
          updatedShipmentTypeFilters = [].concat(updatedShipmentTypeFilters, val);
        } else {
          updatedShipmentTypeFilters.push(val);
        }
      }
    });
    var request = {
      nodeId: nodeId,
      shipmentTypeFilters: updatedShipmentTypeFilters
    };
    var _temp2 = _catch(function () {
      var args = getAPIGatewayRequestForContainerData(request);
      return Promise.resolve(getAPIGatewayDataFromParent(args)).then(function (response) {
        var output = response.data;
        if (output.containerMetrics) {
          dispatch({
            type: "GET_CONTAINER_METRICS_RESPONSE",
            containerMetrics: getContainerMetrics(output.containerMetrics)
          });
        }
        if (output.containers) {
          dispatch({
            type: "GET_CONTAINER_DATA_RESPONSE",
            containers: getContainerList(output.containers, dispatch),
            containersForVisualView: getContainersForVisualView(output.containers)
          });
        }
      });
    }, function () {
      console.log("Error");
    });
    return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getPackageDetailsFromApi = function getPackageDetailsFromApi(dispatch, shipmentTypeFilters) {
  try {
    var nodeId = getNodeId();
    var mappedFilters = getMappingForPackageFilters(shipmentTypeFilters);
    var request = {
      nodeId: nodeId,
      packageStatusMap: {
        PendingStow: []
      },
      filters: mappedFilters
    };
    var _temp = _catch(function () {
      var args = getAPIGatewayRequestForPackageDetails(request);
      return Promise.resolve(getAPIGatewayDataFromParent(args)).then(function (response) {
        var output = response.data;
        if (output.packageResultList) {
          dispatch({
            type: "GET_PACKAGE_DETAILS_RESPONSE",
            packageResultList: getPackageResultList(output.packageResultList)
          });
        }
      });
    }, function () {
      console.log("Error");
    });
    return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
  } catch (e) {
    return Promise.reject(e);
  }
};
function getContainerInfo(dispatch, shipmentTypeFilters) {
  getContainerFromApi(dispatch, shipmentTypeFilters);
}
function getPackageMetricsInfo(dispatch, shipmentTypeFilters) {
  getPackageMetrics(dispatch, shipmentTypeFilters);
}
function getPackageDetailsInfo(dispatch, shipmentTypeFilters) {
  getPackageDetailsFromApi(dispatch, shipmentTypeFilters);
}
function getMappingForPackageFilters(shipmentTypeFilters) {
  var updatedShipmentTypeFilters = [];
  shipmentTypeFilters.forEach(function (selectedValue) {
    if (Object.keys(PackageTypeMapForFetchingPackageMetrics).includes(selectedValue)) {
      var val = PackageTypeMapForFetchingPackageMetrics[selectedValue];
      if (Array.isArray(val)) {
        updatedShipmentTypeFilters = [].concat(updatedShipmentTypeFilters, val);
      } else {
        updatedShipmentTypeFilters.push(val);
      }
    }
  });
  var filters = [];
  if (updatedShipmentTypeFilters.length != 0) {
    filters = [{
      __type: "TermFilter:http://internal.amazon.com/coral/com.amazon.containervisibilityservice.model.filter/",
      filterMap: {
        SHIPMENT_TYPE: updatedShipmentTypeFilters
      }
    }];
  }
  return filters;
}
function getAPIGatewayRequestForContainerData(request) {
  return {
    resourcePath: "/cvs/container/data",
    httpMethod: "post",
    processName: "stow",
    requestBody: request
  };
}
function getAPIGatewayRequestForPackageMetricsData(request) {
  return {
    resourcePath: "/cvs/package/metrics",
    httpMethod: "post",
    processName: "stow",
    requestBody: request
  };
}
function getAPIGatewayRequestForPackageDetails(request) {
  return {
    resourcePath: "/cvs/package/details",
    httpMethod: "post",
    processName: "stow",
    requestBody: request
  };
}
function getPackageMetricsData(packageMetricsData) {
  return {
    pendingStowCount: packageMetricsData.pendingStowCount,
    stowCompliance: packageMetricsData.stowCompliance
  };
}
function getContainerMetrics(containerMetrics) {
  return {
    closeSuccessRate: containerMetrics.closeSuccessRate,
    stageCompliance: containerMetrics.stageCompliance,
    loadingCompliance: containerMetrics.loadingCompliance,
    departCompliance: containerMetrics.departCompliance,
    pendingCloseCount: containerMetrics.pendingCloseCount,
    pendingStageCount: containerMetrics.pendingStageCount,
    pendingDepartCount: containerMetrics.pendingDepartCount,
    closeFailedCount: containerMetrics.closeFailedCount
  };
}
function getContainerList(containers, dispatch) {
  var containersWithNoRisk = [];
  var containerWithRisk = [];
  var atRiskContainersCount = 0;
  containers.forEach(function (container) {
    if (!container.isAtRisk) {
      var containerWithNoRiskModel = {
        openedTime: container.openedTime,
        closedTime: container.closedTime,
        criticalPullTime: container.criticalPullTime,
        containerId: container.containerId,
        resourceLabel: container.resourceLabel,
        containerState: convertStatus(container.containerState),
        status: container.containerState,
        volume: container.volume,
        vrID: container.vrID,
        destination: container.destination,
        stackingFilter: container.stackingFilter,
        cptDDMM: convertSecondsToDDMM(container.criticalPullTime),
        cptHHMM: convertSecondsToHHMM(container.criticalPullTime),
        openedTimeDDMM: convertSecondsToDDMM(container.openedTime),
        openedTimeHHMMSS: convertSecondsToHHMMSS(container.openedTime),
        isAtRisk: container.isAtRisk
      };
      containersWithNoRisk.push(containerWithNoRiskModel);
    } else {
      var containerWithRiskModel = {
        openedTime: container.openedTime,
        closedTime: container.closedTime,
        criticalPullTime: container.criticalPullTime,
        containerId: container.containerId,
        resourceLabel: container.resourceLabel,
        containerState: convertStatus(container.containerState),
        status: container.containerState,
        volume: container.volume,
        vrID: container.vrID,
        destination: container.destination,
        stackingFilter: container.stackingFilter,
        cptDDMM: convertSecondsToDDMM(container.criticalPullTime),
        cptHHMM: convertSecondsToHHMM(container.criticalPullTime),
        openedTimeDDMM: convertSecondsToDDMM(container.openedTime),
        openedTimeHHMMSS: convertSecondsToHHMMSS(container.openedTime),
        isAtRisk: container.isAtRisk
      };
      atRiskContainersCount = atRiskContainersCount + 1;
      containerWithRisk.push(containerWithRiskModel);
    }
  });
  dispatch({
    type: "GET_AT_RISK_CONTAINERS_COUNT",
    atRiskContainerCount: atRiskContainersCount
  });
  var sortedContainerWithRisk = sortContainers(containerWithRisk);
  var sortedContainerWithNoRisk = sortContainers(containersWithNoRisk);
  return sortedContainerWithRisk.concat(sortedContainerWithNoRisk);
}
function sortContainers(containers) {
  containers.sort(function (a, b) {
    return a.criticalPullTime < b.criticalPullTime ? -1 : a.criticalPullTime > b.criticalPullTime ? 1 : 0;
  });
  return containers;
}
function getContainersForVisualView(containers) {
  var group_to_values = containers.reduce(function (obj, item) {
    obj[item.criticalPullTime] = obj[item.criticalPullTime] || [];
    var container = {
      openedTime: item.openedTime,
      containerId: item.containerId,
      resourceLabel: item.resourceLabel,
      status: item.status,
      volume: item.volume,
      VrID: item.vrID,
      destination: item.destination,
      stackingFilter: item.stackingFilter,
      isAtRisk: item.isAtRisk,
      sortOrder: getSortOrderForContainers(item.status)
    };
    obj[item.criticalPullTime].push(container);
    return obj;
  }, {});
  var groups = Object.keys(group_to_values).map(function (key) {
    return {
      criticalPullTime: key,
      containers: group_to_values[key]
    };
  });
  groups.sort(function (a, b) {
    return a.criticalPullTime < b.criticalPullTime ? -1 : a.criticalPullTime > b.criticalPullTime ? 1 : 0;
  });
  var result = [];
  result = customModel(groups);
  return result;
}
function customModel(groups) {
  var result = [];
  groups.forEach(function (container) {
    var containerModel = {
      criticalPullTime: convertLocaleTime(parseInt(container.criticalPullTime, 10)),
      containers: getModeledContainer(container)
    };
    result.push(containerModel);
  });
  return result;
}
function getModeledContainer(container) {
  container.containers.sort(function (a, b) {
    return a.sortOrder < b.sortOrder ? -1 : a.sortOrder > b.sortOrder ? 1 : 0;
  });
  var AtRiskContainers = [];
  var NoRiskContainers = [];
  container.containers.forEach(function (entity) {
    if (entity.isAtRisk === true) {
      AtRiskContainers.push(entity);
    } else {
      NoRiskContainers.push(entity);
    }
  });
  return NoRiskContainers.concat(AtRiskContainers);
}
function convertStatus(status) {
  if (status === "OPENED") return [1, 0, 0, 0, 0];else if (status === "CLOSED") return [1, 1, 0, 0, 0];else if (status === "STAGED") return [1, 1, 1, 0, 0];else if (status === "LOADED") return [1, 1, 1, 1, 0];else if (status === "CLOSE_FAILED") return [1, -1, 0, 0, 0];
  return [1, 1, 1, 1, 1];
}
function getPackageResultList(packageResultList) {
  var result = [];
  packageResultList.forEach(function (packageResultList) {
    var packageResultModel = {
      minutesInState: packageResultList.minutesInState,
      reason: packageResultList.reason,
      routeCode: packageResultList.routeCode,
      sortZone: packageResultList.sortZone,
      state: packageResultList.state,
      trackingId: packageResultList.trackingId
    };
    result.push(packageResultModel);
  });
  return result;
}
function getSortOrderForContainers(containerState) {
  if (containerState === "OPENED") return 1;else if (containerState === "CLOSED") return 2;else if (containerState === "STAGED") return 3;else if (containerState === "LOADED") return 4;else if (containerState === "DEPARTED") return 5;else if (containerState === "CLOSE_FAILED") return 6;
}

var ContainerDataReducer = function ContainerDataReducer(state, action) {
  switch (action.type) {
    case "LOAD_CONTAINER_DATA":
      getContainerInfo(action.data.dispatch, action.data.shipmentTypeFilters);
      return state;
    case "GET_CONTAINER_METRICS_RESPONSE":
      return _extends({}, state, {
        containerMetrics: action.containerMetrics
      });
    case "GET_CONTAINER_DATA_RESPONSE":
      return _extends({}, state, {
        containers: action.containers,
        containersForVisualView: action.containersForVisualView
      });
    case "GET_AT_RISK_CONTAINERS_COUNT":
      return _extends({}, state, {
        atRiskContainerCount: action.atRiskContainerCount
      });
    default:
      return state;
  }
};

var ContainerDataContext = createContext();
var ContainerDataContextProvider = function ContainerDataContextProvider(props) {
  var state = {
    containers: [],
    containerMetrics: {
      closeSuccessRate: 0,
      stageCompliance: 0,
      loadingCompliance: 0,
      departCompliance: 0,
      pendingCloseCount: 0,
      pendingStageCount: 0,
      pendingDepartCount: 0,
      closeFailedCount: 0
    },
    containersForVisualView: [],
    atRiskContainerCount: 0,
    shipmentTypeFilters: []
  };
  var _useReducer = useReducer(ContainerDataReducer, state),
    ViewModelA = _useReducer[0],
    DispatchA = _useReducer[1];
  return /*#__PURE__*/React.createElement(ContainerDataContext.Provider, {
    value: {
      ViewModelA: ViewModelA,
      DispatchA: DispatchA
    }
  }, props.children);
};

var filterOption = function filterOption(container, filter, key, viewModel) {
  if (!viewModel[filter] || viewModel[filter].length === 0) {
    return true;
  }
  var result = false;
  viewModel[filter].forEach(function (filterValue) {
    if (container[key] === filterValue) {
      result = true;
    }
  });
  return result;
};
var atRiskFilter = function atRiskFilter(container, viewModel) {
  if (viewModel["status"] && viewModel["status"].length !== 0 && viewModel["status"][0] === ContainerMetric.AT_RISK) {
    return container.isAtRisk;
  }
  return true;
};

var ContainerFilterReducer = function ContainerFilterReducer(state, action) {
  switch (action.type) {
    case "SELECT_STATUS":
      return _extends({}, state, {
        status: action.status,
        containerState: action.containerState
      });
    case "REMOVE_ALL_FILTER":
      {
        var newState = _extends({}, state);
        Object.entries(state).forEach(function (entry) {
          var key = entry[0];
          var values = entry[1];
          if (Array.isArray(values) && values.length && key !== 'data') {
            newState[key] = [];
          }
        });
        return newState;
      }
    case "REMOVE_FILTER":
      {
        var _extends2;
        var _action$data = action.data,
          key = _action$data.key,
          value = _action$data.value;
        state[key] = state[key].filter(function (item) {
          return item !== value;
        });
        var newItem = state[key].filter(function (item) {
          return item !== value;
        });
        return _extends({}, state, (_extends2 = {}, _extends2[key] = newItem, _extends2));
      }
    default:
      return state;
  }
};

var ContainerFilterContext = createContext();
var ContainerFilterContextProvider = function ContainerFilterContextProvider(props) {
  var initialState = {
    viewType: TABULAR_GRID_VIEW,
    status: [],
    containerState: []
  };
  var _useReducer = useReducer(ContainerFilterReducer, initialState),
    ViewModelF = _useReducer[0],
    DispatchF = _useReducer[1];
  return /*#__PURE__*/React.createElement(ContainerFilterContext.Provider, {
    value: {
      ViewModelF: ViewModelF,
      DispatchF: DispatchF
    }
  }, props.children);
};

var ReverseVisualGridView = function ReverseVisualGridView() {
  var _useState = useState(false),
    screenState = _useState[0],
    setScreenState = _useState[1];
  var _useDeviceLayout = useDeviceLayout(),
    spacingInset_shorthand2 = _useDeviceLayout.spacingInset_shorthand2;
  var _useContext = useContext(ContainerDataContext),
    ViewModelA = _useContext.ViewModelA;
  var _useContext2 = useContext(ContainerFilterContext),
    ViewModelF = _useContext2.ViewModelF;
  var ContainersForVisualView = ViewModelA.containers;
  ContainersForVisualView = ContainersForVisualView.filter(function (container) {
    return filterOption(container, "containerState", "status", ViewModelF);
  }).filter(function (container) {
    return atRiskFilter(container, ViewModelF);
  });
  ContainersForVisualView = getContainersForVisualView(ContainersForVisualView);
  var close_failed_icon = css({
    color: '#cc0c39',
    position: 'relative',
    marginTop: '-7px',
    marginRight: '-7px',
    float: 'right'
  });
  var getToolTipBody = function getToolTipBody(container) {
    return /*#__PURE__*/React.createElement(Column, {
      className: "tooltip-text",
      spacing: "none"
    }, /*#__PURE__*/React.createElement(Row, {
      alignmentHorizontal: "center"
    }, /*#__PURE__*/React.createElement("b", null, container.containerId), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Column, {
      spacing: "none",
      alignmentHorizontal: "left"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        textAlign: 'left'
      }
    }, "ContainerState: ", container.status), /*#__PURE__*/React.createElement("span", {
      style: {
        textAlign: 'left'
      }
    }, "ResourceLabel: ", container.resourceLabel), /*#__PURE__*/React.createElement("span", {
      style: {
        textAlign: 'left'
      }
    }, "StackingFilter: ", container.stackingFilter)));
  };
  var toggleScreen = function toggleScreen() {
    setScreenState(!screenState);
  };
  var getRouteColor = function getRouteColor(status) {
    switch (status) {
      case PENDING_CLOSE:
        return "#F39C12";
      case PENDING_STAGE:
        return "#CB2FBF";
      case PENDING_LOADING:
        return "#FAD000";
      case PENDING_DEPART:
        return "#47C2EC";
      case DEPARTED:
        return "#98C91E";
      case AT_RISK:
        return "#FFFFFF";
      case CLOSED_FAILED:
        return "#F39C12";
      default:
        return "#BBC0C1";
    }
  };
  var getContainerState = function getContainerState(containerState) {
    switch (containerState) {
      case "OPENED":
        return PENDING_CLOSE;
      case "CLOSED":
        return PENDING_STAGE;
      case "STAGED":
        return PENDING_LOADING;
      case "LOADED":
        return PENDING_DEPART;
      case "DEPARTED":
        return DEPARTED;
      case "CLOSE_FAILED":
        return CLOSED_FAILED;
      case "AT_RISK":
        return AT_RISK;
      default:
        return "#BBC0C1";
    }
  };
  var boxWidth = 16;
  var boxHeight = 16;
  var closedFailedIconSrc = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjIgMjIiPjxjaXJjbGUgY3g9IjExIiBjeT0iLTEwNDEuMzYiIHI9IjgiIHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwLTEgMC0xMDMwLjM2KSIgb3BhY2l0eT0iLjk4IiBmaWxsPSIjZGE0NDUzIi8+PHBhdGggZD0ibS0yNi4zMDkgMTguMDdjLTEuMTggMC0yLjEzNS45NjgtMi4xMzUgMi4xMjl2MTIuODJjMCAxLjE3Ni45NDggMi4xMjkgMi4xMzUgMi4xMjkgMS4xODMgMCAyLjEzNS0uOTY4IDIuMTM1LTIuMTI5di0xMi44MmMwLTEuMTc2LS45NDYtMi4xMjktMi4xMzUtMi4xMjl6bTAgMjEuMzQ4Yy0xLjE4IDAtMi4xMzUuOTU0LTIuMTM1IDIuMTM1IDAgMS4xOC45NTQgMi4xMzUgMi4xMzUgMi4xMzUgMS4xODEgMCAyLjEzNS0uOTU0IDIuMTM1LTIuMTM1IDAtMS4xOC0uOTUyLTIuMTM1LTIuMTM1LTIuMTM1eiIgdHJhbnNmb3JtPSJtYXRyaXgoLjMwMDU2IDAgMCAuMzAwNTYgMTguOTAyIDEuNzI4KSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIi8+PC9zdmc+";
  var getSquareBox = function getSquareBox(color, height, width) {
    return /*#__PURE__*/React.createElement(Box, {
      minHeight: height,
      minWidth: width,
      maxHeight: height,
      maxWidth: width,
      backgroundColor: color
    });
  };
  var getDefaultLegend = function getDefaultLegend(color, labelId, defaultLabel) {
    return /*#__PURE__*/React.createElement(Row, {
      wrap: "none",
      spacing: "small"
    }, renderBox(color, defaultLabel), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: labelId,
      defaultMessage: defaultLabel
    })));
  };
  var getBoxColor = function getBoxColor(isAtRisk, status) {
    if (isAtRisk === true) status = "AT_RISK";
    var convert = getContainerState(status);
    return getRouteColor(convert);
  };
  var getSquareBoxWithBoundary = function getSquareBoxWithBoundary(color) {
    return /*#__PURE__*/React.createElement(Box, {
      minHeight: boxHeight,
      minWidth: boxWidth,
      maxHeight: boxHeight,
      maxWidth: boxWidth,
      backgroundColor: "#FF0000",
      spacingInset: "xxsmall"
    }, getSquareBox(color, boxHeight - 4, boxWidth - 4));
  };
  var renderContainerBox = function renderContainerBox(color, isAtRisk, containerState) {
    return isAtRisk ? getSquareBoxWithBoundary(color) : getSquareBox2(color, boxWidth, boxHeight, containerState);
  };
  var getSquareBox2 = function getSquareBox2(color, height, width, containerState) {
    return /*#__PURE__*/React.createElement(Box, {
      minHeight: height,
      minWidth: width,
      maxHeight: height,
      maxWidth: width,
      backgroundColor: color
    }, containerState === 'CLOSE_FAILED' && getCloseFailedIcon());
  };
  var getCloseFailedIcon = function getCloseFailedIcon() {
    return /*#__PURE__*/React.createElement("img", {
      className: close_failed_icon,
      alt: "closeFailed",
      src: closedFailedIconSrc,
      width: "16px",
      height: "16px"
    });
  };
  var renderBox = function renderBox(color, defaultLabel) {
    return defaultLabel === AT_RISK ? getSquareBoxWithBoundary(color) : getSquareBox(color, boxWidth, boxHeight);
  };
  var renderVisualGridBoxes = function renderVisualGridBoxes(index) {
    return index.map(function (container) {
      return /*#__PURE__*/React.createElement("a", {
        style: {
          textDecoration: "none",
          cursor: "pointer"
        }
      }, /*#__PURE__*/React.createElement(Row, {
        className: "html-tooltip",
        spacing: "none",
        spacingInset: "none"
      }, getToolTipBody(container), renderContainerBox(getBoxColor(container.isAtRisk, container.status), container.isAtRisk, container.status)));
    });
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
    widths: ["grid-12"],
    alignmentVertical: "top",
    spacingInset: spacingInset_shorthand2,
    wrap: "down"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FullScreen, {
    enabled: screenState,
    onChange: function onChange(enabled) {
      return setScreenState(enabled);
    }
  }, /*#__PURE__*/React.createElement(ScrollableElementWrapper, null, /*#__PURE__*/React.createElement(Table, {
    showStripes: false,
    headerColumns: 1,
    stickyHeaderColumn: true,
    headerRows: 1,
    spacing: "small",
    fixHeaderRows: true,
    showDividers: false
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "left",
    width: "10%"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    position: "right",
    title: "The CPT presented on this page is based on the distribution of packages (most frequent CPT among all containerized packages) and may differ from FMC's CPT",
    id: "tooltip.cpt"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.CPT",
    defaultMessage: "CPT"
  }))), /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "center",
    width: "15%"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.Containers",
    defaultMessage: "Containers"
  })), /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "right",
    width: "75%"
  }, /*#__PURE__*/React.createElement(Row, {
    widths: ["grid-10", "grid-2"],
    spacing: "xlarge",
    alignmentHorizontal: "left"
  }, /*#__PURE__*/React.createElement(Row, {
    spacing: "large"
  }, getDefaultLegend(getRouteColor(PENDING_CLOSE), "reverse.pendingClose", PENDING_CLOSE), getDefaultLegend(getRouteColor(PENDING_STAGE), "reverse.pendingStage", PENDING_STAGE), getDefaultLegend(getRouteColor(PENDING_LOADING), "reverse.pendingLoading", PENDING_LOADING), getDefaultLegend(getRouteColor(PENDING_DEPART), "reverse.pendingDepart", PENDING_DEPART), getDefaultLegend(getRouteColor(DEPARTED), "reverse.departed", DEPARTED), getDefaultLegend(getRouteColor(AT_RISK), "reverse.isAtRisk", AT_RISK), /*#__PURE__*/React.createElement(Row, {
    wrap: "none",
    spacing: "small"
  }, /*#__PURE__*/React.createElement("img", {
    className: close_failed_icon,
    alt: "closeFailed",
    src: closedFailedIconSrc,
    width: "16px",
    height: "16px"
  }), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.closeFailed",
    defaultMessage: "Closed Failed"
  }))))), /*#__PURE__*/React.createElement(Row, {
    alignmentHorizontal: "right",
    spacing: "none"
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: toggleScreen,
    type: "secondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.toggleFullscreen",
    defaultMessage: "Toggle fullscreen"
  }))))), ContainersForVisualView.map(function (index) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: index
    }, /*#__PURE__*/React.createElement(TableCell, {
      alignmentHorizontal: "center"
    }, index.criticalPullTime), /*#__PURE__*/React.createElement(TableCell, {
      alignmentHorizontal: "center"
    }, index.containers.length), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Row, {
      width: "100%",
      spacing: "small",
      wrap: "down"
    }, renderVisualGridBoxes(index.containers))));
  })))))));
};

var ExportCSV = function ExportCSV(props) {
  var csvLink = React.useRef();
  var _useState = useState([]),
    csvData = _useState[0],
    setCSVData = _useState[1];
  useEffect(function () {
    if (csvData.length > 0) {
      csvLink.current.link.click();
    }
  }, [csvData]);
  var exportCSVFile = function exportCSVFile() {
    if (props.csvDataProvider) {
      var result = props.csvDataProvider();
      if (Array.isArray(result)) {
        setCSVData(result);
      }
    }
  };
  var fileName = props.filePrefix + "_" + new Date().toISOString().slice(0, 10) + ".csv";
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
    width: "100%",
    alignmentHorizontal: "right",
    spacingInset: "none",
    spacing: "none"
  }, props.isLink ? /*#__PURE__*/React.createElement(Link, {
    type: "secondary",
    onClick: exportCSVFile
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.exportCSV",
    defaultMessage: "Export To CSV"
  })) : /*#__PURE__*/React.createElement(Button, {
    type: "tertiary",
    size: "small",
    onClick: exportCSVFile
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.exportCSV",
    defaultMessage: "Export To CSV"
  })), /*#__PURE__*/React.createElement(CSVLink, {
    data: csvData,
    ref: csvLink,
    filename: fileName,
    target: "_blank",
    fileencoding: "UTF-8"
  })));
};

function getPendingStowDataInCSVFormat(pendingStowList) {
  var csvData = [];
  csvData.push(PENDING_STOW_TABLE_COLUMNS);
  pendingStowList.forEach(function (pendingStowObject) {
    var rowData = [];
    rowData.push(pendingStowObject.trackingId);
    rowData.push(pendingStowObject.routeCode);
    rowData.push(pendingStowObject.state);
    rowData.push(pendingStowObject.reason);
    rowData.push(pendingStowObject.sortZone);
    csvData.push(rowData);
  });
  return csvData;
}
function getContainerDataInCSVFormat(containerDataList) {
  var csvData = [];
  csvData.push(CONTAINER_TABLE_COLUMNS);
  containerDataList.forEach(function (container) {
    var rowData = [];
    rowData.push(container.containerId);
    rowData.push(container.status);
    rowData.push(container.resourceLabel);
    rowData.push(container.volume);
    rowData.push(container.destination);
    rowData.push(container.stackingFilter);
    rowData.push(convertLocaleTime(container.openedTime));
    rowData.push(convertLocaleTime(container.closedTime));
    rowData.push(convertLocaleTime(container.criticalPullTime));
    rowData.push(container.vrID);
    csvData.push(rowData);
  });
  return csvData;
}

var Timer = function Timer(_ref) {
  var startTime = _ref.startTime;
  var initialSeconds = Math.floor(startTime);
  var _useState = useState(initialSeconds),
    seconds = _useState[0],
    setSeconds = _useState[1];
  useEffect(function () {
    var intervalId = setInterval(function () {
      setSeconds(function (prevSeconds) {
        return prevSeconds + 1;
      });
    }, 1000);
    return function () {
      return clearInterval(intervalId);
    };
  }, []);
  var hours = Math.floor(seconds / 3600);
  var minutes = Math.floor(seconds % 3600 / 60);
  var displaySeconds = seconds % 60;
  var formattedTime = hours > 0 ? String(hours).padStart(2, '0') + ":" + String(minutes).padStart(2, '0') + ":" + String(displaySeconds).padStart(2, '0') : String(minutes).padStart(2, '0') + ":" + String(displaySeconds).padStart(2, '0');
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: '12px',
      color: 'red'
    }
  }, formattedTime));
};

var ReverseTableGridView = function ReverseTableGridView() {
  var _useDeviceLayout = useDeviceLayout(),
    spacingInset_shorthand2 = _useDeviceLayout.spacingInset_shorthand2;
  var _useContext = useContext(ContainerDataContext),
    ViewModelA = _useContext.ViewModelA;
  var _useContext2 = useContext(ContainerFilterContext),
    ViewModelF = _useContext2.ViewModelF;
  var _useState = useState(1),
    currentPage = _useState[0],
    setCurrentPage = _useState[1];
  var changePage = function changePage(pageNumber) {
    setCurrentPage(pageNumber);
  };
  var _useState2 = useState(100),
    pageCount = _useState2[0],
    setPageCount = _useState2[1];
  var customColorForCheck = css({
    color: "mediumseagreen"
  });
  var customColorForClose = css({
    color: "#00A8E1"
  });
  var customColorForCloseFailed = css({
    color: "#FF0000"
  });
  var getRedirectLink = function getRedirectLink(containerId) {
    var nodeId = getNodeId();
    var baseUrl = "";
    baseUrl = getRegion() === "jp" ? "https://trans-logistics-fe.amazon.com/sortcenter/tantei?nodeId=" : getRegion() === "eu" ? "https://trans-logistics-eu.amazon.com/sortcenter/tantei?nodeId=" : "https://trans-logistics.amazon.com/sortcenter/tantei?nodeId=";
    var parsedContainerId = JSON.parse(containerId);
    return baseUrl + nodeId + "&searchType=Container&searchId=" + parsedContainerId;
  };
  var redirectToTroubleshootingToolPage = function redirectToTroubleshootingToolPage(containerId) {
    var url = getRedirectLink(containerId);
    window.open(url, "_blank");
  };
  var containerDataConversionHandler = function containerDataConversionHandler() {
    return getContainerDataInCSVFormat(ViewModelA.containers);
  };
  var Containers = ViewModelA.containers;
  Containers = Containers.filter(function (container) {
    return filterOption(container, "containerState", "status", ViewModelF);
  }).filter(function (container) {
    return atRiskFilter(container, ViewModelF);
  });
  var _useState3 = useState("departed"),
    sortColumn = _useState3[0],
    setSortColumn = _useState3[1];
  var _useState4 = useState("ascending"),
    sortDirection = _useState4[0],
    setSortDirection = _useState4[1];
  var onSort = function onSort(_ref) {
    var sortColumn = _ref.sortColumn,
      sortDirection = _ref.sortDirection;
    setSortDirection(sortDirection);
    setSortColumn(sortColumn);
    setCurrentPage(1);
  };
  var customSort = function customSort(a, b, sortColumn, direction) {
    if (sortColumn === "departed") {
      var onesInA = a.containerState.reduce(function (first, second) {
        return first + second;
      }, 0);
      var onesInB = b.containerState.reduce(function (first, second) {
        return first + second;
      }, 0);
      if (onesInA < onesInB) {
        return direction === "ascending" ? -1 : 1;
      } else if (onesInA > onesInB) {
        return direction === "ascending" ? 1 : -1;
      } else {
        return a.criticalPullTime < b.criticalPullTime ? -1 : a.criticalPullTime > b.criticalPullTime ? 1 : 0;
      }
    } else {
      console.log("Other than departed column has been selected ");
      if (a[sortColumn] < b[sortColumn]) {
        return direction === "ascending" ? -1 : 1;
      }
      if (a[sortColumn] > b[sortColumn]) {
        return direction === "ascending" ? 1 : -1;
      }
      return 0;
    }
  };
  Containers.sort(function (a, b) {
    return customSort(a, b, sortColumn, sortDirection);
  });
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
    widths: ["grid-12"],
    alignmentVertical: "top",
    spacingInset: spacingInset_shorthand2
  }, /*#__PURE__*/React.createElement(ScrollableElementWrapper, null, /*#__PURE__*/React.createElement(Table, {
    showDividers: true,
    showStripes: true,
    headerRows: 1,
    spacing: "small",
    headerColumns: 1,
    stickyHeaderColumn: true,
    fixHeaderRows: true,
    sortColumn: sortColumn,
    sortDirection: sortDirection,
    onSort: onSort
  }, /*#__PURE__*/React.createElement(TableActionBar, null, /*#__PURE__*/React.createElement(Row, {
    width: "100%",
    spacingInset: spacingInset_shorthand2,
    alignmentHorizontal: "right"
  }, /*#__PURE__*/React.createElement(Select, {
    label: "Container Count",
    value: pageCount,
    onChange: setPageCount,
    placeholder: "100",
    size: "small",
    width: 180
  }, /*#__PURE__*/React.createElement(SelectOption, {
    value: "10",
    label: "10"
  }), /*#__PURE__*/React.createElement(SelectOption, {
    value: "20",
    label: "20"
  }), /*#__PURE__*/React.createElement(SelectOption, {
    value: "50",
    label: "50"
  }), /*#__PURE__*/React.createElement(SelectOption, {
    value: "100",
    label: "100"
  }), /*#__PURE__*/React.createElement(SelectOption, {
    value: "200",
    label: "200"
  })), /*#__PURE__*/React.createElement(ExportCSV, {
    isLink: true,
    csvDataProvider: containerDataConversionHandler,
    filePrefix: "Container"
  }))), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "left",
    sortColumn: "criticalPullTime"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    position: "right",
    title: "The CPT presented on this page is based on the distribution of packages (most frequent CPT among all containerized packages) and may differ from FMC's CPT",
    id: "tooltip.cpt"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.CPT",
    defaultMessage: "CPT"
  }))), /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "left",
    sortColumn: "openedTime"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.OpenedAt",
    defaultMessage: "Opened At"
  })), /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "left",
    sortColumn: "containerId"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.ContainerID",
    defaultMessage: "Container ID"
  })), /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "left",
    sortColumn: "resourceLabel"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.ResourceLabel",
    defaultMessage: "Resource Label"
  })), /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "left"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.Opened",
    defaultMessage: "Opened"
  })), /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "left"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.Closed",
    defaultMessage: "Closed"
  })), /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "left"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.Staged",
    defaultMessage: "Staged"
  })), /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "left"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.Loaded",
    defaultMessage: "Loaded"
  })), /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "left",
    sortColumn: "departed"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.Departed",
    defaultMessage: "Departed"
  })), /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "left"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.Volume",
    defaultMessage: "Volume"
  })), /*#__PURE__*/React.createElement(TableCell, {
    alignmentHorizontal: "left",
    sortColumn: "destination"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reverse.Destination",
    defaultMessage: "Destination"
  }))), Containers && Containers.slice((currentPage - 1) * pageCount, currentPage * pageCount).map(function (container, index) {
    var color = container.isAtRisk ? '#FEF2B8' : '#FFFFFF';
    return /*#__PURE__*/React.createElement(TableRow, {
      key: index,
      backgroundColor: color
    }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Row, null, convertLocaleTime(container.criticalPullTime))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Row, null, convertLocaleTime(container.openedTime))), /*#__PURE__*/React.createElement(TableCell, {
      alignmentHorizontal: "left"
    }, /*#__PURE__*/React.createElement(Link, {
      type: "secondary",
      onClick: function onClick() {
        return redirectToTroubleshootingToolPage(JSON.stringify(container.containerId));
      }
    }, container.containerId)), /*#__PURE__*/React.createElement(TableCell, null, container.resourceLabel), container.containerState.map(function (val, index) {
      return /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginRight: '8px'
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        tokens: getIcon(container, index),
        className: val > 0 ? customColorForCheck : val < 0 || shouldActivateTimer(container, index) ? customColorForCloseFailed : customColorForClose
      })), shouldActivateTimer(container, index) ? /*#__PURE__*/React.createElement(Timer, {
        startTime: (Date.now() - container.closedTime) / 1000
      }) : null));
    }), /*#__PURE__*/React.createElement(TableCell, null, container.volume), /*#__PURE__*/React.createElement(TableCell, null, container.destination));
  })), /*#__PURE__*/React.createElement(Row, {
    alignmentVertical: "top",
    alignmentHorizontal: "center"
  }, /*#__PURE__*/React.createElement(Pagination, {
    numberOfPages: Math.ceil(Containers.length / pageCount),
    onChange: function onChange(pageNumber) {
      return changePage(pageNumber);
    },
    currentPage: currentPage
  })))));
};

var ReverseRouteGridView = function ReverseRouteGridView() {
  var _useContext = useContext(ReverseFilterContext),
    viewModelF = _useContext.viewModelF;
  return /*#__PURE__*/React.createElement("div", null, viewModelF.waveViewType === VISUAL_GRID_VIEW ? /*#__PURE__*/React.createElement(ReverseVisualGridView, null) : /*#__PURE__*/React.createElement(ReverseTableGridView, null));
};

var PackageDataReducer = function PackageDataReducer(state, action) {
  switch (action.type) {
    case "LOAD_PACKAGE_DATA":
      getPackageMetricsInfo(action.data.dispatch, action.data.shipmentTypeFilters);
      return _extends({}, state, {
        shipmentTypeFilters: action.data.shipmentTypeFilters
      });
    case "LOAD_FILTERED_PACKAGE_DATA":
      getPackageDetailsInfo(action.data.dispatch, action.data.shipmentTypeFilters);
      return _extends({}, state, {
        shipmentTypeFilters: action.data.shipmentTypeFilters
      });
    case "GET_PACKAGE_DETAILS_RESPONSE":
      {
        return _extends({}, state, {
          packageResultList: action.packageResultList
        });
      }
    case "GET_PACKAGE_METRICS_RESPONSE":
      return _extends({}, state, {
        packageMetricsData: action.packageMetricsData
      });
    default:
      return state;
  }
};

var PackageDataContext = createContext();
var PackageMetricDataContextProvider = function PackageMetricDataContextProvider(props) {
  var state = {
    packageMetricsData: {
      pendingStowCount: 0,
      stowCompliance: 0
    },
    shipmentTypeFilters: [],
    packageResultList: []
  };
  var _useReducer = useReducer(PackageDataReducer, state),
    ViewModelB = _useReducer[0],
    DispatchB = _useReducer[1];
  return /*#__PURE__*/React.createElement(PackageDataContext.Provider, {
    value: {
      ViewModelB: ViewModelB,
      DispatchB: DispatchB
    }
  }, props.children);
};

var ActionableMetricView = function ActionableMetricView(data) {
  var onMetricCountClick = function onMetricCountClick() {
    if (data.onMetricCountClick) {
      data.onMetricCountClick();
    }
  };
  var _useDeviceLayout = useDeviceLayout(),
    isMobile = _useDeviceLayout.isMobile;
  var headerFont = isMobile ? "b100" : "b200";
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    type: headerFont,
    alignment: "start"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: data.containerStatus.title,
    defaultMessage: data.containerStatus.message
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    type: "d50",
    alignment: "start"
  }, /*#__PURE__*/React.createElement(Link, {
    type: "secondary",
    onClick: onMetricCountClick
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: data.containerStatus.color
    }
  }, data.containerStatus.value)))));
};

var ReverseMetricView = function ReverseMetricView(_ref) {
  var _items, _widths, _spacing;
  var descAlt = _ref.descAlt;
  var _useDeviceLayout = useDeviceLayout(),
    spacingInset_shorthand4 = _useDeviceLayout.spacingInset_shorthand4;
  var _useContext = useContext(ContainerDataContext),
    ViewModelA = _useContext.ViewModelA,
    DispatchA = _useContext.DispatchA;
  var _useContext2 = useContext(PackageDataContext),
    ViewModelB = _useContext2.ViewModelB,
    DispatchB = _useContext2.DispatchB;
  var _useContext3 = useContext(ContainerFilterContext),
    DispatchF = _useContext3.DispatchF;
  var _useContext4 = useContext(ShipmentTypeFilterContext),
    ViewModelG = _useContext4.ViewModelG;
  useEffect(function () {
    var repeat = withRefreshTime(function () {
      DispatchA({
        type: "LOAD_CONTAINER_DATA",
        data: {
          dispatch: DispatchA,
          shipmentTypeFilters: ViewModelG.shipmentTypeFilters
        }
      });
    }, 30000);
    return function () {
      if (repeat) {
        clearInterval(repeat);
      }
    };
  }, [ViewModelG.shipmentTypeFilters]);
  useEffect(function () {
    var repeat = withRefreshTime(function () {
      DispatchB({
        type: "LOAD_PACKAGE_DATA",
        data: {
          dispatch: DispatchB,
          shipmentTypeFilters: ViewModelG.shipmentTypeFilters
        }
      });
    }, 30000);
    return function () {
      if (repeat) {
        clearInterval(repeat);
      }
    };
  }, [ViewModelG.shipmentTypeFilters]);
  var getPendingStowListURL = function getPendingStowListURL() {
    return "#pendingStowList";
  };
  var ReversePackages = function ReversePackages() {
    return /*#__PURE__*/React.createElement(Box, {
      type: "outline",
      spacingInset: "400"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
      type: "H200"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reverse.reversePackages",
      defaultMessage: "Reverse Packages"
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
      type: "b200",
      alignment: "start"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      type: "b200",
      id: "reverse.pendingStow",
      defaultMessage: "Pending Stow"
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
      type: "d50",
      alignment: "start"
    }, /*#__PURE__*/React.createElement(Link, {
      href: getPendingStowListURL(),
      type: "secondary"
    }, ViewModelB.packageMetricsData.pendingStowCount, " ")))), /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Tooltip, {
      position: "right",
      title: "% of eligible packages stowed to a reverse container in the past 24 hours.",
      id: "tooltip.stowCompliance"
    }, /*#__PURE__*/React.createElement(Text, {
      type: "b200",
      alignment: "start"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reverse.stowCompliance",
      defaultMessage: "Stow Compliance"
    })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
      type: "d50",
      alignment: "start"
    }, (ViewModelB.packageMetricsData.stowCompliance * 100.00).toFixed(2) === "100.00" ? /*#__PURE__*/React.createElement("span", {
      style: {
        color: "#00688D"
      }
    }, ViewModelB.packageMetricsData.stowCompliance * 100.00 + "%") : /*#__PURE__*/React.createElement("span", {
      style: {
        color: "#CB330B"
      }
    }, (ViewModelB.packageMetricsData.stowCompliance * 100.00).toFixed(1) + "%"))))));
  };
  var ReverseContainers = function ReverseContainers() {
    return /*#__PURE__*/React.createElement(Box, {
      type: "outline",
      spacingInset: "400"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
      type: "H200"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reverse.reverseContainers",
      defaultMessage: "Reverse Containers"
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(ActionableMetricView, {
      onMetricCountClick: function onMetricCountClick() {
        return DispatchF({
          type: 'SELECT_STATUS',
          status: [ContainerMetric.PENDING_CLOSE],
          containerState: [ContainerState.OPENED, ContainerState.CLOSE_FAILED]
        });
      },
      containerStatus: {
        title: "reverse.pendingClose",
        message: "Pending Close",
        value: ViewModelA.containerMetrics.pendingCloseCount,
        color: "#00688D"
      }
    }), /*#__PURE__*/React.createElement(ActionableMetricView, {
      onMetricCountClick: function onMetricCountClick() {
        return DispatchF({
          type: 'SELECT_STATUS',
          status: [ContainerMetric.PENDING_STAGE],
          containerState: [ContainerState.CLOSED]
        });
      },
      containerStatus: {
        title: "reverse.pendingStage",
        message: "Pending Stage",
        value: ViewModelA.containerMetrics.pendingStageCount,
        color: "#00688D"
      }
    }), /*#__PURE__*/React.createElement(ActionableMetricView, {
      onMetricCountClick: function onMetricCountClick() {
        return DispatchF({
          type: 'SELECT_STATUS',
          status: [ContainerMetric.PENDING_DEPART],
          containerState: [ContainerState.STAGED, ContainerState.LOADED]
        });
      },
      containerStatus: {
        title: "reverse.pendingDepart",
        message: "Pending Depart",
        value: ViewModelA.containerMetrics.pendingDepartCount,
        color: "#00688D"
      }
    }), /*#__PURE__*/React.createElement(ActionableMetricView, {
      onMetricCountClick: function onMetricCountClick() {
        return DispatchF({
          type: 'SELECT_STATUS',
          status: [ContainerMetric.CLOSE_FAILED],
          containerState: [ContainerState.CLOSE_FAILED]
        });
      },
      containerStatus: {
        title: "reverse.closeFailed",
        message: "Close Failed",
        value: ViewModelA.containerMetrics.closeFailedCount,
        color: "#00688D"
      }
    })));
  };
  var ContainerScanCompliance = function ContainerScanCompliance() {
    return /*#__PURE__*/React.createElement(Box, {
      type: "outline",
      spacingInset: "400"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
      type: "H200"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reverse.containerScanCompliance",
      defaultMessage: "Container Scan Compliance"
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Tooltip, {
      position: "right",
      title: "% of containers which are successfully closed in the past 7 days.",
      id: "tooltip.closeSuccess"
    }, /*#__PURE__*/React.createElement(Text, {
      type: "b200",
      alignment: "start"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reverse.closeSuccess",
      defaultMessage: "Close Success"
    })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
      type: "d50",
      alignment: "start"
    }, formatMetricsPercentage(ViewModelA.containerMetrics.closeSuccessRate)))), /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Tooltip, {
      position: "right",
      title: "% of containers staged or loaded within 24 hours of container close.",
      id: "tooltip.stageCompliance"
    }, /*#__PURE__*/React.createElement(Text, {
      type: "b200",
      alignment: "start"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reverse.stageCompliance",
      defaultMessage: "Stage Compliance"
    })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
      type: "d50",
      alignment: "start"
    }, formatMetricsPercentage(ViewModelA.containerMetrics.stageCompliance)))), /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Tooltip, {
      position: "right",
      title: "% of containers loaded on D-1 out of all containers with D-1 CPT.",
      id: "tooltip.loadingCompliance"
    }, /*#__PURE__*/React.createElement(Text, {
      type: "b200",
      alignment: "start"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reverse.loadingCompliance",
      defaultMessage: "Loading Compliance"
    })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
      type: "d50",
      alignment: "start"
    }, formatMetricsPercentage(ViewModelA.containerMetrics.loadingCompliance)))), /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Tooltip, {
      position: "right",
      title: "% of containers departed on D-1 out of all containers with D-1 CPT.",
      id: "tooltip.departCompliance"
    }, /*#__PURE__*/React.createElement(Text, {
      type: "b200",
      alignment: "start"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reverse.departCompliance",
      defaultMessage: "Depart Compliance"
    })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
      type: "d50",
      alignment: "start"
    }, formatMetricsPercentage(ViewModelA.containerMetrics.departCompliance))))));
  };
  var AtRisk = function AtRisk() {
    return /*#__PURE__*/React.createElement(Box, {
      type: "outline",
      spacingInset: "400"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Tooltip, {
      position: "right",
      title: descAlt
    }, /*#__PURE__*/React.createElement(Text, {
      type: "H200",
      alignment: "start"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reverse.atRisk",
      defaultMessage: "At risk"
    }))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(ActionableMetricView, {
      onMetricCountClick: function onMetricCountClick() {
        return DispatchF({
          type: 'SELECT_STATUS',
          status: [ContainerMetric.AT_RISK],
          containerState: []
        });
      },
      containerStatus: {
        title: "reverse.containerCount",
        message: "Container Count",
        value: ViewModelA.atRiskContainerCount,
        color: ViewModelA.atRiskContainerCount === 0 ? "#00688D" : "#CB330B"
      }
    })));
  };
  var ShipmentTypeFilterBox = function ShipmentTypeFilterBox() {
    return /*#__PURE__*/React.createElement(ShipmentTypeField, null);
  };
  return /*#__PURE__*/React.createElement(Column, {
    spacingInset: spacingInset_shorthand4,
    spacing: "small"
  }, /*#__PURE__*/React.createElement(Responsive, {
    query: "max-width",
    props: {
      items: (_items = {
        default: [/*#__PURE__*/React.createElement(ReversePackages, null), /*#__PURE__*/React.createElement(ReverseContainers, null), /*#__PURE__*/React.createElement(ContainerScanCompliance, null), /*#__PURE__*/React.createElement(AtRisk, null), /*#__PURE__*/React.createElement(ShipmentTypeFilterBox, null)]
      }, _items[LARGE] = [/*#__PURE__*/React.createElement(ReversePackages, null), /*#__PURE__*/React.createElement(ReverseContainers, null), /*#__PURE__*/React.createElement(ContainerScanCompliance, null), /*#__PURE__*/React.createElement(AtRisk, null), /*#__PURE__*/React.createElement(ShipmentTypeFilterBox, null)], _items),
      widths: (_widths = {
        default: []
      }, _widths[LARGE] = ["35%", "35%", "30%", "100%"], _widths),
      spacing: (_spacing = {
        default: "large"
      }, _spacing[LARGE] = "large", _spacing)
    }
  }, function (_ref2) {
    var items = _ref2.items,
      widths = _ref2.widths,
      spacing = _ref2.spacing;
    return /*#__PURE__*/React.createElement(Row, {
      spacing: spacing,
      maxWidth: "100%",
      widths: widths,
      wrap: "down",
      alignmentVertical: "stretch"
    }, items);
  }));
};
var formatMetricsPercentage = function formatMetricsPercentage(value) {
  var percentage = value * 100;
  if (percentage === 100) {
    return "100%";
  }
  var rounded = Math.round(percentage * 10) / 10;
  return rounded.toFixed(1).replace(/\.0$/, '') + "%";
};
ReverseMetricView.propTypes = {
  desc: propTypes.string,
  descAlt: propTypes.string
};

var ContainerFilter = function ContainerFilter() {
  var _useContext = useContext(ContainerFilterContext),
    ViewModelF = _useContext.ViewModelF,
    DispatchF = _useContext.DispatchF;
  var isFilterSet = function isFilterSet() {
    var result = false;
    Object.entries(ViewModelF).forEach(function (entry) {
      var values = entry[1];
      result = result || Array.isArray(values) && values.length;
    });
    return result;
  };
  var clearAllFilters = function clearAllFilters() {
    DispatchF({
      type: 'REMOVE_ALL_FILTER'
    });
  };
  return /*#__PURE__*/React.createElement(Column, {
    spacingInset: "none large",
    spacing: "none"
  }, /*#__PURE__*/React.createElement(Row, {
    width: "100%",
    spacingInset: "small none none none"
  }, /*#__PURE__*/React.createElement(Row, {
    spacing: "small"
  }, Object.entries(ViewModelF).map(function (entry) {
    var key = entry[0];
    var values = entry[1];
    return Array.isArray(values) && key !== 'containerState' ? values.map(function (value) {
      return /*#__PURE__*/React.createElement(Tag, {
        key: value,
        type: "theme",
        onClose: function onClose() {
          return DispatchF({
            type: 'REMOVE_FILTER',
            data: {
              key: key,
              value: value
            }
          });
        }
      }, value);
    }) : null;
  }), isFilterSet() ? /*#__PURE__*/React.createElement(Link, {
    onClick: clearAllFilters,
    type: "secondary"
  }, "Clear all") : null)));
};

var ReverseTab = function ReverseTab() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DeviceLayoutProvider, null, /*#__PURE__*/React.createElement(ContainerFilterContextProvider, null, /*#__PURE__*/React.createElement(ReverseFilterContextProvider, null, /*#__PURE__*/React.createElement(ShipmentTypeFilterContextProvider, null, /*#__PURE__*/React.createElement(ContainerDataContextProvider, null, /*#__PURE__*/React.createElement(PackageMetricDataContextProvider, null, /*#__PURE__*/React.createElement(ReverseHeader, REVERSE_PAGE_HEADERS.REVERSE), /*#__PURE__*/React.createElement(ContainerFilter, null), /*#__PURE__*/React.createElement(ReverseMetricView, HOVER_DESCRIPTION.AT_RISK), /*#__PURE__*/React.createElement(ReverseViewSelector, null), /*#__PURE__*/React.createElement(ReverseRouteGridView, null))))))));
};

var PendingStowDetails = function PendingStowDetails(props) {
  var _useContext = useContext(PackageDataContext),
    ViewModelB = _useContext.ViewModelB,
    DispatchB = _useContext.DispatchB;
  var _useState = useState(""),
    baseURL = _useState[0],
    setBaseURL = _useState[1];
  useEffect(function () {
    try {
      var filter = JSON.parse(props.value);
      DispatchB({
        type: "LOAD_FILTERED_PACKAGE_DATA",
        data: {
          dispatch: DispatchB,
          shipmentTypeFilters: filter
        }
      });
      getDocumentURL().then(function (value) {
        setBaseURL(value);
      });
    } catch (error) {
      console.log("Error while loading filtered data ", error);
    }
  }, []);
  var PendingStowList = ViewModelB.packageResultList;
  var _useState2 = useState(1),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var changePage = function changePage(pageNumber) {
    setCurrentPage(pageNumber);
  };
  var getPackageShareableLink = function getPackageShareableLink(trackingId) {
    var shareablePath = "detailPage/";
    var redirectPath = new URL(baseURL.replace("containerSummary", "search"));
    redirectPath.searchParams.set("shareableLink", shareablePath.concat(trackingId));
    return redirectPath;
  };
  var pendingStowDataConversionHandler = function pendingStowDataConversionHandler() {
    return getPendingStowDataInCSVFormat(ViewModelB.packageResultList);
  };
  return /*#__PURE__*/React.createElement(Column, {
    spacingInset: "large medium none large"
  }, /*#__PURE__*/React.createElement(Row, {
    width: "100%",
    spacingInset: "none",
    alignmentHorizontal: "right"
  }, /*#__PURE__*/React.createElement(ExportCSV, {
    isLink: true,
    csvDataProvider: pendingStowDataConversionHandler,
    filePrefix: "PendingStow"
  })), /*#__PURE__*/React.createElement(BreadcrumbGroup, null, /*#__PURE__*/React.createElement(Breadcrumb, {
    href: "#containerSummary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "pendingStowList.reverse",
    defaultMessage: "Reverse"
  })), /*#__PURE__*/React.createElement(Breadcrumb, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "pendingStowList.pendingStowList",
    defaultMessage: "Pending Stow List"
  }))), /*#__PURE__*/React.createElement(Heading, {
    level: 1
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "pendingStowList.packageStowList",
    defaultMessage: "Pending Stow List"
  })), /*#__PURE__*/React.createElement(ScrollableElementWrapper, null, /*#__PURE__*/React.createElement(Table, {
    headerRows: 1,
    spacing: "small"
  }, /*#__PURE__*/React.createElement(TableRow$1, null, /*#__PURE__*/React.createElement(TableCell$1, {
    sortColumn: "trackingId"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "pendingStowList.trackingId",
    defaultMessage: "Tracking Id"
  })), /*#__PURE__*/React.createElement(TableCell$1, {
    sortColumn: "state"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "pendingStowList.state",
    defaultMessage: "State"
  })), /*#__PURE__*/React.createElement(TableCell$1, {
    sortColumn: "reason"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "pendingStowList.reason",
    defaultMessage: "Reason"
  })), /*#__PURE__*/React.createElement(TableCell$1, {
    sortColumn: "sortZone"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "pendingStowList.location",
    defaultMessage: "Sort Zone"
  }))), PendingStowList && PendingStowList.slice((currentPage - 1) * 15, currentPage * 15).map(function (pendingObject) {
    return /*#__PURE__*/React.createElement(TableRow$1, {
      key: pendingObject.trackingId
    }, /*#__PURE__*/React.createElement(Link, {
      target: "_blank",
      rel: "noreferrer noopener",
      href: getPackageShareableLink(pendingObject.trackingId)
    }, /*#__PURE__*/React.createElement(TableCell$1, null, pendingObject.trackingId)), /*#__PURE__*/React.createElement(TableCell$1, null, pendingObject.state), /*#__PURE__*/React.createElement(TableCell$1, null, pendingObject.reason), /*#__PURE__*/React.createElement(TableCell$1, null, pendingObject.sortZone));
  })), /*#__PURE__*/React.createElement(Row, {
    alignmentVertical: "top",
    alignmentHorizontal: "center"
  }, /*#__PURE__*/React.createElement(Pagination, {
    numberOfPages: Math.ceil(PendingStowList.length / 15),
    onChange: function onChange(pageNumber) {
      return changePage(pageNumber);
    },
    currentPage: currentPage
  }))));
};

var getSessionData = function getSessionData() {
  return sessionStorage.getItem("filter");
};
var PendingStowList = function PendingStowList() {
  var filter = getSessionData();
  console.log("Value of filter in session storage :", filter);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PackageMetricDataContextProvider, null, /*#__PURE__*/React.createElement(PendingStowDetails, {
    value: filter
  })));
};

export { PendingStowList, ReverseTab };
//# sourceMappingURL=index.modern.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/container-visibility-website/dist/index.modern.js
// module id = 272
// module chunks = 0